// src/layouts/CustomLayout.jsx
import { Outlet } from 'react-router-dom';

export default function CustomLayout() {
  return (
    <div
      style={{
        backgroundColor: 'var(--bg)',
        color: 'var(--text)',
        minHeight: '100vh',
      }}
    >
      <Outlet />
    </div>
  );
}
